<template>
  <div>
    <div class="case">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <div class="list">
        <div class="module">
          <div>
            <div class="title">陆家嘴智慧社区三维GIS平台</div>
          </div>
          <div>
            <div class="title">上海世博会应急处置GIS平台</div>
          </div>
          <div>
            <div class="title">城市大脑综合治理可视化应用</div>
          </div>
          <div>
            <div class="title">产业园智慧园区运维管理平台</div>
          </div>
          <div>
            <div class="title">广州展览中心智慧展馆管理平台</div>
          </div>
          <div>
            <div class="title">中国电信上海进博会实时保障系统</div>
          </div>
          <template v-if="page>=2">
            <div>
              <div class="title">智慧园区物联网综合管理平台</div>
            </div>
            <div>
              <div class="title">上海科技馆智能安防管理平台</div>
            </div>
            <div>
              <div class="title">万科物业地理信息GIS平台</div>
            </div>
            <div>
              <div class="title">中国科学院国家土壤信息服务平台</div>
            </div>
            <div>
              <div class="title">监所三维可视化系统</div>
            </div>
            <div>
              <div class="title">数据中心GIS+BIM三维可视化</div>
            </div>
          </template>
          <template v-if="page>=3">
            <div>
              <div class="title">危化品智能监管平台</div>
            </div>
            <div>
              <div class="title">全球传染病分布与流行GIS地理信息</div>
            </div>
            <div>
              <div class="title">智慧旅游可视化应用平台</div>
            </div>
            <div>
              <div class="title">德州国土局应用服务系统</div>
            </div>
            <div>
              <div class="title">智慧公交运营管理系统</div>
            </div>
            <div>
              <div class="title">海信位置监控云GIS平台</div>
            </div>
          </template>
        </div>
      </div>
      <div class="more" v-if="page!=3" @click="page=page+1">查看更多</div>
    </div>
    <div class="mobile-case">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <div class="list">
        <div class="module">
          <div>
            <div class="title">陆家嘴智慧社区三维GIS平台</div>
          </div>
          <div>
            <div class="title">上海世博会应急处置GIS平台</div>
          </div>
          <div>
            <div class="title">城市大脑综合治理可视化应用</div>
          </div>
          <div>
            <div class="title">产业园智慧园区运维管理平台</div>
          </div>
          <div>
            <div class="title">广州展览中心智慧展馆管理平台</div>
          </div>
          <div>
            <div class="title">中国电信上海进博会实时保障系统</div>
          </div>
          <template v-if="page>=2">
            <div>
              <div class="title">智慧园区物联网综合管理平台</div>
            </div>
            <div>
              <div class="title">上海科技馆智能安防管理平台</div>
            </div>
            <div>
              <div class="title">万科物业地理信息GIS平台</div>
            </div>
            <div>
              <div class="title">中国科学院国家土壤信息服务平台</div>
            </div>
            <div>
              <div class="title">监所三维可视化系统</div>
            </div>
            <div>
              <div class="title">数据中心GIS+BIM三维可视化</div>
            </div>
          </template>
          <template v-if="page>=3">
            <div>
              <div class="title">危化品智能监管平台</div>
            </div>
            <div>
              <div class="title">全球传染病分布与流行GIS地理信息</div>
            </div>
            <div>
              <div class="title">智慧旅游可视化应用平台</div>
            </div>
            <div>
              <div class="title">德州国土局应用服务系统</div>
            </div>
            <div>
              <div class="title">智慧公交运营管理系统</div>
            </div>
            <div>
              <div class="title">海信位置监控云GIS平台</div>
            </div>
          </template>
        </div>
      </div>
      <div class="more" v-if="page!=3" @click="page=page+1">
        <p>查看更多</p>
        <div>
          <i class="el-icon-arrow-down"></i>
          <i class="el-icon-arrow-down"></i>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: 'Case',
  metaInfo: {
    title:
      '三维可视化渲染应用成功案例-上海臻图信息技术有限公司',
    meta: [
      {
        name: 'keywords',
        content:
          '三维GIS可视化,三维GIS渲染,三维应用案例,GIS+BIM案例,VR三维全景案例'
      },
      {
        name: 'description',
        content:
          '智慧城市和物联网行业内空间信息三维可视化渲染典型成功案例,包含政府、企业、事业、互联网等各个行业项目案例。'
      }
    ]
  },
  data () {
    return {
      bannerData: {
        title: '经典案例',
        p:
          '臻图信息依托多年的产品研发和项目实施经验，建立了完备的软件系统设计咨询服务体系，力争成为业内服务最好的智慧城市信息可视化服务企业。'
      },
      page: 1
    }
  },
  mounted: function () {}
}
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../assets/images/case/banner.jpg");
}
.case {
  .list {
    .module {
      padding: 100px 0;
      display: flex;
      flex-wrap: wrap;
      > div {
        width: 584px;
        height: 500px;
        background: #ccc;
        display: inline-block;
        margin-right: 21px;
        margin-top: 21px;
        padding: 0 20px;
        box-sizing: border-box;
        box-shadow: 0px 0px 60px 10px rgba(13, 37, 62, 0.1);
        color: #4b4b4b;
        background: no-repeat center center / 100% 100%;
        vertical-align: top;
        &:nth-of-type(2n) {
          margin-right: 0;
        }
        @List: 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16 ,17, 18;
        .ml-loop(@list,@i:1,@val:extract(@list,@i)) when (length(@list)>=@i) {
          &:nth-of-type(@{val}) {
            background-image: url("../assets/images/case/case_@{val}.jpg");
          }
          .ml-loop(@list, (@i+1));
        }
        .ml-loop(@List);
        .title {
          font-size: 20px;
          margin-top: 428px;
          text-align: center;
        }
      }
    }
  }
  .more {
    margin-bottom: 50px;
  }
}
.mobile-case {
  display: none;
  width: 100%;
  flex-direction: column;
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../assets/images/case/banner.jpg");
    background-position: 50%;
    background-size: cover;
    height: 28rem;
  }
  .list {
    width: 100%;
    box-sizing: border-box;
    padding: 0 2rem 3rem 2rem;
    .module {
      width: 100%;
      >div {
        width: 33.5rem;
        height: 22rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 3rem;
        font-family: 'Normal';
        color: #fff;
        .title {
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.2);
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 1.8rem;
          font-weight: bold;
          line-height: 3rem;
        }
        .btn {
          width: 11.5rem;
          height: 3.2rem;
          line-height: 3.2rem;
          background: #3C80E8;
          margin-top: 2rem;
          text-align: center;
          color: #fff;
          font-size: 1.2rem;
          border: none;
          cursor: pointer;
          border-radius: 2rem;
        }
        @List: 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18;
        .ml-loop(@list,@i:1,@val:extract(@list,@i)) when (length(@list)>=@i) {
          &:nth-of-type(@{val}) {
            background-image: url("../assets/images/case/case_@{val}.jpg");
            background-repeat: no-repeat;
            background-size: cover;
          }
          .ml-loop(@list, (@i+1));
        }
        .ml-loop(@List);
      }
    }
  }
  .more{
    margin-bottom: 3rem;
    width: 11.5rem;
    height: 3.5rem;
    border-radius: 1.75rem;
    background: #3C80E8;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    border: none;
    p {
      font-size: 1.2rem;
      font-weight: 350;
      line-height: 2rem;
    }
    >div {
      display: flex;
      flex-direction: column;
      height: 1.6rem;
      margin-left: 1rem;
      i {
        font-size: 1rem;
        &:nth-of-type(2) {
          margin-top: -0.6rem;
        } 
      }
    }
  }
}
@media (max-width: 1024px) {
  .case {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-case { 
    display: flex !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/case.vue